@if (name) {
  <pr-icon
    class="icon-table"
    [name]="name"
    [width]="width || 20"
    [viewBoxWidth]="viewBoxWidth"
    [viewBoxHeight]="viewBoxHeight"
  ></pr-icon>
}
<span
  [class]="labelDefaultClass ? labelDefaultClass : 'fs-13 fw-500'"
  [ngClass]="labelClass"
>
  <ng-content></ng-content>
</span>
@if (tooltip) {
  <pr-tooltip-icon [tooltip]="tooltip" [width]="16"> </pr-tooltip-icon>
}
